
<template>
  <PageComponent>
    <template v-slot:header>
      <div class="flex justify-between items-center">
        <h1 class="text-3xl font-bold text-gray-900">Event Attendance</h1>
        <router-link
          :to="{ name: 'Event-create' }"
          class="
            py-2
            px-3
            text-white
            bg-blue-500
            rounded-md
            hover:bg-indigo-600
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 inline-block"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 4v16m8-8H4"
            />
          </svg>
          ADD
        </router-link>
      </div>
    </template>
    <div v-if="events.loading">
      <LoadindView />
    </div>
     <div v-else>
      <div class="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
        <div
          class="inline-block min-w-full shadow-md rounded-lg overflow-hidden"
        >
          <table class="min-w-full leading-normal">
            <thead>
              <tr>
                <th
                  class="
                    px-5
                    py-3
                    border-b-2 border-gray-200
                    bg-gray-100
                    text-left text-xs
                    font-semibold
                    text-gray-700
                    uppercase
                    tracking-wider
                  "
                >
                  S/N
                </th>
                <th
                  class="
                    px-5
                    py-3
                    border-b-2 border-gray-200
                    bg-gray-100
                    text-center text-xs
                    font-semibold
                    text-gray-700
                    uppercase
                    tracking-wider
                  "
                >
                  Name
                </th>
                <th
                  class="
                    px-5
                    py-3
                    border-b-2 border-gray-200
                    bg-gray-100
                    text-right text-xs
                    font-semibold
                    text-gray-700
                    uppercase
                    tracking-wider
                  "
                >
                  Added by
                </th>
                <th
                  class="
                    px-5
                    py-3
                    border-b-2 border-gray-200
                    bg-gray-100
                    text-right text-xs
                    font-semibold
                    text-gray-700
                    uppercase
                    tracking-wider
                  "
                >
                  Date
                </th>
                
                
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(event, index) in events.data.data"
                :key="index"
              >
                <!-- <tr> -->
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  {{ getserialNumber(events, index) }}
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm   text-center">
                  <p class="text-gray-900 whitespace-no-wrap">
                    {{ event?.guest?.name }}
                  </p>
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap   text-right">
                    {{ event?.user?.name }}
                  </p>
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap   text-right">
                    {{ event?.created_at }}
                  </p>
                </td>
                
                
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- pagination -->
      <div class="flex justify-center mt-5">
        <nav
          class="relative z-0 inline-flex justify-center rounded-md shadow-sm"
          aria-label="Pagination"
        >
          <a
            v-for="(link, i) of events.links"
            :key="i"
            :disabled="!link.url"
            href="#"
            @click="getForPage($event, link)"
            aria-current="page"
            class="
              relative
              inline-flex
              items-center
              px-4
              py-2
              border
              text-sm
              font-medium
              whitespace-nowrap
            "
            :class="[
              link.active
                ? 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600'
                : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
              i === 0 ? 'rounded-l-md' : '',
              i === events.links.length - 1 ? 'rounded-r-md' : '',
            ]"
            v-html="link.label"
          >
          </a>
        </nav>
      </div>
    </div>

  </PageComponent>
</template>

<script setup>
import PageComponent from "@/components/Layouts/pageComponent.vue";
import LoadindView from "@/components/LoadindView.vue";
import store from "@/store";
import { computed } from "@vue/runtime-core";

const events = computed(() => {
  return store.state.events;
});

const getserialNumber = (events, index) => {
  return events.data.current_page * 50 - 50 + index + 1;
};
store.dispatch("getEvents");
function getForPage(ev, link) {
  ev.preventDefault();

  if (!link.url || link.active) {
    return;
  }
  store.dispatch("getEvents", { url: link.url });
}
</script>

